import * as React from 'react';

import { CardSectionNew } from '../../components/CardSectionNew';
import { PossibleAssignmentLayout } from '../../components/PossibleAssignmentNew';
import { usePossibleAssignmentProps } from './hooks';

export const PossibleAssignmentContainer: React.FC = () => {
  const props = usePossibleAssignmentProps();

  if (!props) {
    return null;
  }

  return (
    <CardSectionNew>
      <PossibleAssignmentLayout {...props} />
    </CardSectionNew>
  );
};
